import React from 'react';
import { Stack, Grow } from '@mui/material';
import AssignSelectedUser from './AssignSelectedUser';
import AssignUserCategory from './AssignUserCategory';

export default function AssignUser({ id, shop, type, users, refetch, isActive }) {
  return (
    <Grow in={isActive}>
      <Stack direction="row" width="100%" columnGap={1}>
        <AssignSelectedUser id={id} shop={shop} refetch={refetch} active={false} users={users} />
        <AssignUserCategory id={id} shop={shop} refetch={refetch} active={false} />
      </Stack>
    </Grow>
  );
}
